// Adds Foreach to NodeLists..
if(typeof NodeList.prototype.forEach !== 'function'){
	NodeList.prototype.forEach = Array.prototype.forEach;
};

if(typeof HTMLCollection.prototype.forEach !== 'function'){
	HTMLCollection.prototype.forEach = Array.prototype.forEach;
};

/* globals require */
window.$ = require('jquery');
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Choices from 'choices.js';
import MicroModal from 'micromodal';
import Swiper from 'swiper/js/swiper';
import CopySliderAccordion from './module/copySliderAccordion';
import Navigation from './module/Navigation';
import ProfileModal from './module/profileModal';
import ReorderPosts from './module/ReorderPosts';
// import Videos from './module/Videos';

window.Deetu = {
	init: function() {
		MicroModal.init({ disableScroll: true, debugMode: false });
		this.initEvents();
		// Videos.init();
		this.AnimatedScroll.init();

		this.singleHeader.init();
		this.homeHeaderSlider.init();
		this.teamSlider.init();
		this.timelineSlider.init();
		this.copySlider.init();
		this.fullWidthEmbed.init();
		this.postSwiper.init();
		this.profileModal.init();
		this.masonryCards.init();
		this.reorderPosts.init();

		try { new Navigation(); } catch (e) { console.error(e); }

		// choicesjs
		document.querySelectorAll('.choices-dropdown').forEach( select => {
			new Choices(select, {
				searchEnabled: false,
				shouldSort: false,
				itemSelectText: ''
			});
		});

		setTimeout(() => {
			if(document.querySelector('.checkbox-wrapper') !== null){
				document.querySelectorAll('.checkbox-wrapper').forEach(el => {
					let input = el.querySelector('.nf-field-element'),
						span = document.createElement("span");

					input.insertAdjacentElement('beforeend', span);
				});
			}
		}, 200);

		if(document.querySelector('#show-download-form') !== null){
			document.querySelector('#show-download-form').addEventListener('click', ev =>{
				ev.preventDefault();

				ev.target.nextElementSibling.style.display = 'block';
				ev.target.style.display = 'none';
			});
		}
	},

	initEvents: function() {
		$(document).bind('scroll mousedown wheel keyup', function(e) {
			if(e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
				$('html, body').stop();
			}
		});

		document.addEventListener('click', e => {
			if(e.target.nodeName !== 'A') {
				return;
			}

			if(!e.target.getAttribute('href') || e.target.getAttribute('href').indexOf('#') || !e.target.hash) {
				return;
			}

			let target = document.querySelector(e.target.hash);

			if(!target) {
				return;
			}

			target.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'start',
			});

			e.preventDefault();
		});
	},

	initMaps: function() {
		if (document.readyState === 'complete') {
			// The page is fully loaded
			this.officeLocations.init();
		} else {
			document.onreadystatechange = () => {
				if (document.readyState === 'complete') {
					// document ready
					this.officeLocations.init();
				}
			};
		}
	}
};

window.Deetu.AnimatedScroll = {
	init: function() {
		if(document.querySelector('.animated-scroll') !== null){
			document.querySelectorAll('.animated-scroll').forEach(el => {
				$(el).on('click', function(ev) {
					ev.preventDefault();
					let hash = ev.target.href.split('#')[1],
						offset = $('#' + hash).offset();

					$('html, body').animate({ scrollTop: (offset.top)}, 500);
				});
			});
		}
	}
};

window.Deetu.teamSlider = {
	init: function() {
		document.querySelectorAll('.team-slider-section').forEach( section => {
            let swiperContainer = section.querySelector('.swiper-container.team-slider');

            new Swiper(swiperContainer, {
                speed: 800,
                allowTouchMove: true,
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 20,
                navigation : {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
        });
	}
};

window.Deetu.timelineSlider = {
	init: function() {
		document.querySelectorAll('.timeline-section').forEach( section => {
            let swiperContainer = section.querySelector('.swiper-container.timeline-slider');

            let swiper = new Swiper(swiperContainer, {
                allowTouchMove: true,
                speed: 800,
                loop: false,
                // slidesPerView: 'auto',
                spaceBetween: 20,
                slidesPerGroup: 1,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                breakpoints: {
                    295: {
                        slidesPerView: 1.2,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    550: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 20,
                    },
                    991: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 20,
                    },
                    1085: {
                        slidesPerGroup: 2,
                        spaceBetween: 20,
                    },
                    1280: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            }) ;

            swiperContainer.querySelectorAll('.timeline__card').forEach( element => {
                element.addEventListener('click', event => {
                    let slideIndex = event.target.dataset.slideIndex;
                    swiper.slideTo(slideIndex, 700);
                });
            });
        });
	}
};

window.Deetu.fullWidthEmbed = {
	init: function() {
		document.querySelectorAll('.full-width-video').forEach( element => {
			var embedModal = document.getElementById('modal-videoplayer'),
				iframe = element.dataset.oembed;

			if ( !embedModal || !iframe ) {
				return;
			}

			element.addEventListener('click', event => {
				var embedContainer = embedModal.querySelector('.embed-container');
				
				embedContainer.innerHTML = iframe;

				MicroModal.show('modal-videoplayer', {
					onClose: function() {
						// clear embed-container inner html
						embedContainer.innerHTML = "";

						// overflow not removed first time onClose is called, fix
						if (document.body.style.overflow === 'hidden') {
							document.body.style.removeProperty("overflow");
						}
					},
				});
			});
		});
	}
};

window.Deetu.postSwiper = {
	init: function() {
		document.querySelectorAll('.posts-by-category-section').forEach( section => {
            let swiperContainer = section.querySelector('.swiper-container.posts-swiper');

			if (!swiperContainer) return;

            swiperContainer.swiper = new Swiper(swiperContainer, {
                allowTouchMove: true,
                speed: 800,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: true
                },
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,
                spaceBetween: 20,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                navigation : {
                    nextEl: section.querySelector('.swiper-button-next'),
                    prevEl: section.querySelector('.swiper-button-prev')
                },
                breakpoints: {
                    550: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    769: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    1280: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    }
                },
            });
            swiperContainer.swiper.autoplay.stop();
            // swiper.updateAutoHeight();
        });

        window.addEventListener('scroll', ev => {
            if(document.querySelector('.swiper-container.posts-swiper') !== null){
                document.querySelectorAll('.swiper-container.posts-swiper').forEach( swiperContainer => {
                    if(typeof swiperContainer.swiper === 'undefined' || swiperContainer.swiper.autoplay.running){
                        return false;
                    }

                    let rect = swiperContainer.getBoundingClientRect(),
                        offset = {
                            top: rect.top + document.body.scrollTop,
                            left: rect.left + document.body.scrollLeft
                        };

                    if(offset.top <= (window.outerHeight/2)){
                        swiperContainer.swiper.autoplay.start();
                    }
                });
            }
        }, { passive: true });
	;}
}

window.Deetu.profileModal = {
	init: function() {
		document.querySelectorAll('.trigger-profile-modal').forEach( element => { new ProfileModal(element) });
	}
};

// Update the translation for masonry cards, onload/resize
window.Deetu.masonryCards = {
	init: function() {
		window.addEventListener('load', this.updateMasonryCardTranslation);
		window.addEventListener('resize', this.updateMasonryCardTranslation);
	},
	updateMasonryCardTranslation: function() {
		document.querySelectorAll('.masonry__card.masonry__card--default, .masonry__card.masonry__card--video').forEach( card => {
			let cardContent = card.querySelector('.card__content');

			if (cardContent) {
				let cardTitle = card.querySelector('.card__title');

				let offset = cardTitle.offsetHeight + 38;
				cardContent.style.transform = "translateY(calc(100% - " + offset + "px))";
			}
		});
	}
};

window.Deetu.homeHeaderSlider = {
	init: function() {
		document.querySelectorAll('.header.home-header').forEach( header => {
            let swiperContainer = header.querySelector('.swiper-container.header-swiper');
            if (swiperContainer === null) return;

            // options modified if swiper is disabled
            let autoplay = { delay: 5000, disableOnInteraction: false },
                allowTouchMove = true;

            let swiperDisabled = swiperContainer.classList.contains('swiper-disabled');

            if (swiperDisabled) {
                autoplay = false;
                allowTouchMove = false;
            }

            new Swiper(swiperContainer, {
                autoplay: autoplay,
                loop: true,
                slidesPerView: 1,
                allowTouchMove: allowTouchMove,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                navigation : {
                    nextEl: header.querySelector('.swiper-button-next'),
                    prevEl: header.querySelector('.swiper-button-prev')
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: !swiperDisabled
                },
            });
        });
	}
};

window.Deetu.singleHeader = {
	init: function() {
		// Adjust article share sidebar position
		const sidebar = document.querySelector('.aside-share');
		const articleHeader = document.querySelector('.article__header');

		if (articleHeader && sidebar && (window.outerWidth > 991)) {
			let headerHeight = articleHeader.getBoundingClientRect().bottom - articleHeader.getBoundingClientRect().top;
			sidebar.style.marginTop = Math.round(headerHeight) + 20 + 'px'; // 20 is article header bottom margin
		}

		if(document.querySelector('#subpage-dropdown') !== null){
			document.querySelectorAll('#subpage-dropdown').forEach(el => {
				el.timeout = null;
				el.addEventListener('change', ev => {
					if(ev.target.value.length){
						ev.target.timeout = setTimeout(() => {
							window.location = ev.target.value;
						}, 500);
					}
				});
			});
		}
	}
};

window.Deetu.copySlider = {
	init: function() {
		document.querySelectorAll('.copy-slider-section:not(.copy-slider-tabbed-section)').forEach( section => {
			let accordion = section.querySelector('.accordion');
			new CopySliderAccordion(accordion);
	
			let swiperContainer = section.querySelector('.swiper-container.slider-swiper');
	
			let swiper = new Swiper(swiperContainer, {
				allowTouchMove: false,
				speed: 800,
				effect: 'fade',
				fadeEffect: { crossFade: true }
			});
	
			accordion.querySelectorAll('.accordion__heading').forEach( (item, index) => {
				 item.addEventListener('click', () => swiper.slideTo(index, 700));
				 item.addEventListener('mouseover', () => swiper.slideTo(index, 700));
			 });
		});
	},
};

// reorder the posts in news grid
window.Deetu.reorderPosts = {
	init: function() {
		document.querySelectorAll('.grid.posts-grid.post-grid-reordergrid').forEach( grid => {
			new ReorderPosts(grid);
		});
	}
};

window.Deetu.officeLocations = {
	init: function() {
		let mapStyle = null;

		// set the map style
		if (wordpress_globals.google_maps_style !== undefined) {
			mapStyle = JSON.parse(wordpress_globals.google_maps_style);
		}

		// add event block selector as the maps function the same

        document.querySelectorAll('.office-locations-section').forEach( section => {
            section.querySelectorAll('.map-container').forEach( mapContainer => {
                let location = new google.maps.LatLng(mapContainer.dataset.lat, mapContainer.dataset.lng)
                let map = mapContainer.querySelector('.map');

                let theMap = new google.maps.Map(map, {
                    center: location,
                    zoom: 12,
                    styles: mapStyle,
                    disableDoubleClickZoom: true,
                    
                    disableDefaultUI: true,
                    
                    // zoomControl: false,
                    // mapTypeControl: false,
                    scaleControl: true,
                    // streetViewControl: false,
                    rotateControl: true,
                    fullscreenControl: true
                });

                new google.maps.Marker({
                    position: location,
                    // title: marker.title,
                    map: theMap,
                    icon: {
                        url: '/wp-content/themes/class/dist/images/map/map-marker-2x.png',
                        size: new google.maps.Size(84, 84),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(21, 21),
                        scaledSize: new google.maps.Size(42, 42)
                    },
                });
            });
        });
	}
};

$(function() {
	'use strict';

	window.Deetu.init();
});
